"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { NavSubMarketListLink } from "./NavSubMarketListLink";

export function NavMarketListRowContainer({ children, text = "market" }) {
  return (
    <Block className={"nav-market-list-market-row-container"} tag={"div"}>
      <Block className={"div-block-30"} tag={"div"}>
        <Block className={"nav-market-list-heading"} tag={"div"}>
          {text}
        </Block>
      </Block>
      <Block className={"nav-sub-market-list"} tag={"div"}>
        {children ?? (
          <>
            <NavSubMarketListLink showSpacer={true} text={"Sub dsfgsdfgdsfg"} />
            <NavSubMarketListLink text={"Sub Market"} />
            <NavSubMarketListLink text={"Sub Market"} />
            <NavSubMarketListLink text={"Sub Market"} />
            <NavSubMarketListLink text={"Sub Market"} />
            <NavSubMarketListLink text={"Sub Market"} />
            <NavSubMarketListLink showSpacer={false} text={"Sub Market"} />
          </>
        )}
      </Block>
    </Block>
  );
}
